import {Pipe, PipeTransform} from '@angular/core';
import {toCompletedAmountByZeroFormat} from '../../../common/functions/utilities-functions';

@Pipe({
  name: 'completeFloatByZero'
})
export class CompleteFloatByZeroPipe implements PipeTransform {

  transform(value: number): string {
    return toCompletedAmountByZeroFormat(value);
  }

}
